import $ from 'jquery';

function showClearSearchButton() {
  if ($('#query').length > 0 && $('#query').val().length > 0) {
    $('.clear-button').css({
      display: 'inline',
    });
  }
}

function setupIdeaLoadingSpinner() {
  $('.list-ideas .idea.is-loading')
    .removeClass('is-loading')
    .find('.fa-spinner')
    .remove();

  $('.list-ideas .idea a.idea-link').on('click', event => {
    $('.list-ideas .idea.is-loading')
      .removeClass('is-loading')
      .find('.fa-spinner')
      .remove();
    $(this)
      .parents('li')
      .addClass('is-loading')
      .prepend('<i class="fa-regular fa-spinner fa-spin fa-2x"></i>');
  });
}

$(document).on('page:change', () => {
  showClearSearchButton();
  setupIdeaLoadingSpinner();
});

$(() => {
  $(document).tooltip({
    selector: 'a[title], [data-title][data-tooltip]',
    trigger: 'hover focus',
  });

  $(document).on('click', '.clear-button', function (event) {
    $('#query').val('');
    $('.clear-button').css({
      display: 'none',
    });
  });

  $(document).on('click', '.login-link', function (event) {
    $('.popover.active').removeClass('active');
    $('.login-popover').addClass('active');
    $('.popover.active #ideas_idea_user_email').focus();
    return false;
  });

  // Old attachment modal without carousel effect, brought back from git history https://github.com/aha-app/aha-app/pull/21756
  // just for classic portal which does not require carousel but still needs to display attached images in modal.
  $(document).on('click', '.attachment.gallery', function (event) {
    const $attachments = $(this).parents('.attachments');
    const isInIdeaResponse = $attachments.closest('.idea-response').length > 0;
    let $attachmentModal = $attachments.find('.attachment-modal');

    // Retrieve modal if it was previously moved to body (only for idea-response)
    if (isInIdeaResponse && $attachmentModal.length === 0) {
      const movedModal = $attachments.data('moved-modal');
      if (movedModal) {
        $attachmentModal = $(movedModal);
      }
    }

    $attachmentModal.find('.item.active').removeClass('active');
    const $activeAttachment = $attachmentModal
      .find(`.attachment-${$(this).attr('data-attachment-id')}`)
      .addClass('active');

    let imageUrl = $activeAttachment.find('img').attr('src');
    if (imageUrl.match(/\.modal/)) {
      imageUrl = imageUrl.replace('.modal', '.html');
    }
    $('.open-attachment').attr('href', imageUrl);

    // Move modal to body if inside idea-response to escape container styling
    if (isInIdeaResponse && !$attachmentModal.parent().is('body')) {
      $attachmentModal.appendTo(document.body);
      $attachments.data('moved-modal', $attachmentModal[0]);
      $attachmentModal.css('position', 'fixed');
    }

    $attachmentModal.modal();
  });
});
